import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import auth from './slices/authSlice'
import profile from './slices/profileSlice'
import role from './slices/roleSlice'
import changeOrganization from './slices/changeOrganizationSlice'
import organizationData from './slices/organizationSlice'

const rootReducer = (asyncReducers) => (state, action) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        profile,
        role,
        changeOrganization,
        organizationData,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}
  
export default rootReducer
